<template>
  <div class="prize prize-bg">
    <div class="title" style="padding: 210px 0 90px;">
      <p style="height: 55px;"></p>
			<!-- <img style="width:187px" src="../../assets/image/match/prize-title.png" alt=""> -->
		</div>
    <div class="title">
      <p style="height: 314px;"></p>
			<!-- <img style="width:1056px" src="../../assets/image/match/prize-stle.jpg" alt=""> -->
		</div>
    <div class="prize-detail-list">
      <div class="prize-detail">
        <div class="img img1">产品设计组</div>
        <div class="prize-txt">
          <p>金奖（1名）：奖金 <span>10</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p>银奖（2名）：奖金各 <span>5</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p>铜奖（5名）：奖金各 <span>2</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p class="line"></p>
          <p>优秀奖（10名）：奖金各 <span>5</span> 千元人民币/奖杯/证书/大赛标识使用权</p>
          <p>入围奖若干：证书/大赛标识使用权</p>
        </div>

        <div class="prize-txt">
          <p>创新发展金奖（10名）：奖金各 <span>3</span> 万元人民币/奖杯/证书</p>
          <p class="line"></p>
          <p>优秀奖（若干）：证书</p>
        </div>
        <div class="img img2">创新企业组</div>

        <div class="img img3">概念设计组</div>
        <div class="prize-txt">
          <p>金奖（1名）：奖金 <span>10</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p>银奖（2名）：奖金各 <span>5</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p>铜奖（5名）：奖金各 <span>2</span> 万元人民币/奖杯/证书/大赛标识使用权</p>
          <p class="line"></p>
          <p>优秀奖（10名）：奖金各 <span>5</span> 千元人民币/奖杯/证书/大赛标识使用权</p>
          <p>入围奖若干：证书/大赛标识使用权</p>
        </div>
      </div>
    </div>
    <!-- 港澳台 -->
    <div class="prize-other-list">
      <div class="img img"></div>
      <div class="prize-txt">
        <p>不分类别评选出港澳台赛区</p>
        <p>金奖<span>1</span>名 ，银奖<span>2</span>名，铜奖<span>3</span>名，优秀奖若干名</p>
      </div>
    </div>
    <div class="prize-other-list second">
      <div class="img img"></div>
      <div class="prize-txt">
        <p style="width: 80%">该奖项由命题企业自主设立，对通过评审，符合企业所需的优秀设计作品，颁发荣誉证书及相关奖励。</p>
      </div>
    </div>
    <!-- 优秀个人 -->
    <div class="prize-other-list third" v-show="false">
      <div class="img img"></div>
      <div class="prize-txt mutline-more">
        <p>1、对积极参与大赛组织、宣传、评选等工作并作出突出贡献的单位和个人，进行通报表扬，颁发相关表彰证书。</p>
        <p>2、面向大赛组织和执行，设置大赛先进单位和先进个人称号。</p>
        <p>3、面向大赛征集，设置大赛优秀组织单位，对组织超300件的高质量作品参赛的单位或个人，颁发奖状并奖励1万元。</p>
        <p>4、面向大赛优秀的产业化、孵化落地单位，设置大赛优秀合作伙伴荣誉称号。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "prize",
}
</script>

<style lang="scss" scoped>
.prize {
  //height: 1486px;
  //height: 2920px;
  height: 1036px;
  height: 2490px;
  margin: auto;
  // background: url('../../assets/image/match/prize-bg.jpg') no-repeat center top;

  .title {
    font-size: 38px;
    font-weight: bold;
    color: rgb(31, 0, 2);
    text-align: center;
  }
}
.prize-detail, .prize-other-list {
  margin-top: 60px;
  overflow: hidden;
  .img, .prize-txt {float: left;width: 600px;overflow: hidden;height: 256px;}
  .img {
    background-position: center center;
    background-repeat: no-repeat;
    color: #fff;font-size: 26px;font-weight: 700;line-height: 256px;text-align: center;
  }
  .img1 {
    // background-image: url('../../assets/image/match/zhusaidao.jpg');
  }
  .img2 {
    // background-image: url('../../assets/image/match/chuangxinzu.jpg');
  }
  .img3 {
    // background-image: url('../../assets/image/match/gainianzu.jpg');
  }
  .prize-txt {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    p {margin-left: 60px;line-height: 32px;font-size: 16px;}
    p span {color: #25877d; font-weight:bold}
    p.line {
      height: 4px;width: 40px;background: #25877d;border-radius: 4px;margin-top: 4px;margin-bottom: 4px;
    }
  }
}
.prize-detail-list {
  height: 770px;margin-bottom: 195px;
}
.prize-other-list {
  margin-top: 0;
  .img {
    background-position: center center;
    background-repeat: no-repeat;
    color: #fff;font-size: 26px;font-weight: 700;line-height: 256px;text-align: center;
  }
  .prize-txt {
    p {margin-left: 30px;}
  }
  .mutline-more {
    p {margin-bottom: 16px;line-height: 28px;}
  }
}
.prize-other-list.second {margin: 190px 0;}
</style>



// WEBPACK FOOTER //
// src/components/Match/prize.vue